/* eslint-disable @typescript-eslint/no-this-alias */
import { RUPEE_SYMBOL } from '@/root/constants'
import type { Options } from 'highcharts'
import { Benchmark } from './types'

const getIndexCalculatorChartOptions = (
  data?: Benchmark[],
  duration?: string,
  amount?: number,
  units?: string,
  mode?: string,
  // absoluteReturns?: number,
  sipInvestedAmount?: number,
  // installments?: number,
): Options => {
  const datum = data?.find(item => item.label === duration) ?? {}

  const chartOptions: Options = {
    title: {
      text: undefined,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
      series: {
        marker: {
          enabled: false,
        },
      },
    },
    series: [
      {
        type: 'column',
        colorByPoint: true,
        colors: data
          ? datum.comparison?.map(item => {
              if (mode === 'sip') {
                return (item.sip_multiplier ?? 1) > 1
                  ? 'rgba(51, 163, 77, 1)'
                  : 'rgba(223, 60, 39, 1)'
              } else {
                return (item.current_value ?? 1) > 1
                  ? 'rgba(51, 163, 77, 1)'
                  : 'rgba(223, 60, 39, 1)'
              }
            })
          : [],
        borderRadius: 3,
        data: datum.comparison?.map(item => {
          if (mode === 'sip') {
            const absoluteReturns = (amount ?? 1) * (item.sip_multiplier ?? 1)
            // if (item.name?.toLowerCase() === 'savings a/c') {
            //   return (
            //     (item.sip_multiplier ?? 1) * (sipInvestedAmount ?? 1) -
            //     (sipInvestedAmount ?? 1)
            //   )
            // }
            return absoluteReturns - (sipInvestedAmount ?? 1)
          }
          // Math.abs(item.sip_multiplier ?? 1)
          else return Math.abs((item.current_value ?? 1) - 1)
        }),
      },
      {
        type: 'column',
        borderRadius: 0,
        data: datum.comparison?.map(item => {
          if (mode === 'sip') {
            return sipInvestedAmount ?? 1
          } else {
            return (item.current_value ?? 1) > 1 ? 1 : item.current_value ?? 1
          }
        }),

        color: 'rgba(189, 189, 189, 1)',
        opacity: 0.7,
      },
    ],

    legend: {
      enabled: false,
    },
    xAxis: {
      categories: datum.comparison?.map(item => item.name ?? ''),
      crosshair: false,
    },
    yAxis: {
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      min: 0,
      labels: { enabled: false },
      title: { text: '' },
      stackLabels: {
        overflow: 'allow',
        crop: false,
        enabled: true,
        formatter: function formatter() {
          if (this.total > 0 && mode === 'sip') {
            // if (
            //   datum.comparison?.[this.x].name?.toLowerCase() === 'savings a/c'
            // ) {
            //   console.info(datum.comparison[this.x].sip_multiplier)
            //   return `${RUPEE_SYMBOL}${(
            //     (datum.comparison[this.x].sip_multiplier ?? 1) *
            //     (sipInvestedAmount ?? 1)
            //   ).toFixed(2)}${units}`
            // }
            return `${RUPEE_SYMBOL}${(
              (datum.comparison?.[this.x].sip_multiplier ?? 1) * (amount ?? 1)
            ).toFixed(2)}${units}`
          } else if (this.total > 0) {
            return `${RUPEE_SYMBOL}${(
              (datum.comparison?.[this.x].current_value ?? 1) * (amount ?? 1)
            ).toFixed(2)}${units}`
          } else return ''
        },
        style: {
          fontSize: '14px',
          color: '#191C1F',
        },
      },
    },
    tooltip: {
      enabled: false,
    },
    chart: {
      height: 250,
    },
  }
  return chartOptions
}

export default getIndexCalculatorChartOptions
